<mat-form-field>
  <input matInput [matDatepicker]="picker" [(ngModel)]="value" [placeholder]="placeholder"  [ngModelOptions]="{updateOn: 'blur'}" name="value" >
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [calendarHeaderComponent]="dayMonthHeader"></mat-datepicker>
</mat-form-field>
